.teamSettingsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  /* padding: 2rem; */
  box-sizing: border-box;
}

.teamHeader {
  color: var(--static-text-strong);
  font-size: 24px;
  margin-bottom: 30px;
  font-weight: 500;
}

.teamContainer {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
}

.teamLabelContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 15px 0 0;
  max-width: 19.5rem;
  min-width: 19.5rem;
}

.teamControlsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  background: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  width: 100%;
}

.userZeroState {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.25rem;
}

.zeroStateIconContainer {
  color: var(--static-text-strong);
}

.zeroStateHeader {
  font-size: 16px;
  color: var(--static-text-strong);
  margin-bottom: 10px;
}

.userZeroStateContentContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.teamLabelHeaderText {
  color: var(--static-text-strong);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
}

.teamLabelSubText {
  color: var(--static-text-weak);
  font-weight: 500;
  font-size: var(--fs-small);
  line-height: 20px;
  margin-bottom: 15px;
}

.inviteButton {
  
}

.teamMemberContainer {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  align-items: center;
  padding: 1.25rem;
  width: 100%;
}

.teamMemberBorder {
  border-bottom: 1px solid var(--static-divider-standard);
}

.memberInfoContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  max-width: 10rem;
  min-width: 10rem;
}

.memberName {
  color: var(--static-text-strong);
  font: 1rem;
}

.memberEmail {
  color: var(--static-text-weak);
  font-size: 0.8rem;
}

.memberStatusContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 6px;
  border-radius: 6px;
  max-width: 5rem;
  min-width: 5rem;
}

.memberActive {
  background: var(--sentiment-background-positive);
  color: var(--sentiment-text-positive);
}
.memberPending {
  background: var(--sentiment-background-notice);
  color: var(--sentiment-text-notice);
}
.memberRemoved {
  background: var(--sentiment-background-negative);
  color: var(--sentiment-text-negative);
}

.memberPermissionsContainer {
  display: flex;
  max-width: 18rem;
  min-width: 18rem;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
}

.permissionContainer {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.permissionText {
  color: var(--static-text-neutral);
}

.buttonsContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.loader::before, .loader::after {
  border-color: var(--static-text-strong);
}
